import {inject, Injectable, signal} from '@angular/core';
import {catchError, of, shareReplay, tap} from 'rxjs';
import {AuthFlowService} from './auth-flow.service';
import {PsdRules} from '../models/psd-rules';
import {DEFAULT_PSD_RULES} from '../../shared/psd-validator';

@Injectable({providedIn: 'root'})
export class PsdRulesService {
  private readonly authFlow = inject(AuthFlowService);

  readonly rules = signal<PsdRules>(DEFAULT_PSD_RULES);

  private request$ = this.authFlow.psdRules().pipe(
    tap(rules => this.rules.set(rules)),
    catchError(() => of(DEFAULT_PSD_RULES)),
    shareReplay({bufferSize: 1, refCount: false}),
  );

  load(): void {
    this.request$.subscribe();
  }

  reload(): void {
    this.request$ = this.authFlow.psdRules().pipe(
      tap(rules => this.rules.set(rules)),
      catchError(() => of(this.rules())),
      shareReplay({bufferSize: 1, refCount: false}),
    );
    this.load();
  }
}
